module.exports = __webpack_public_path__ + "img/tjt_baja.a780725c.png";